import { render } from "./StaffBook.vue?vue&type=template&id=2071fd4c&scoped=true"
import script from "./StaffBook.vue?vue&type=script&lang=js"
export * from "./StaffBook.vue?vue&type=script&lang=js"

import "./StaffBook.vue?vue&type=style&index=0&id=2071fd4c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2071fd4c"]])

export default __exports__